export default __webpack_public_path__ + "static/media/Candara_Bold_Italic.aeac56c9.ttf";